// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2c3Sw","title":"Info_title__2Xp62","links":"Info_links__3NAeB","link":"Info_link__118mC","logo":"Info_logo__1dYSL"};